import React, { useEffect, useState } from 'react';
import { API_URL } from '../../actions/settings';
import QuicksightQEmbed from '../../components/extras/QuicksightQEmbed';
import { IonContent } from '@ionic/react';
import LoadingDots from '../../components/extras/LoadingDots';

interface QuicksightQProps {
    topicId:string
}

async function getUrl(topicId:string,token: string) {
    return fetch(`${API_URL}/hey_alpha/url/${topicId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: token,
      },
    }).then((res) => {
          if (res.ok) {
            return res.json();
          }
          else{
              return false

          }
        }).catch(error => {
          return false
        });
  }

const QuicksightQ: React.FC<QuicksightQProps> = ({topicId}) => {
    const [loaded,setLoaded] = useState(false)

    useEffect(() => {

        const handleDash = async (topicId: string) => {
        const dashboard = new QuicksightQEmbed()
          await dashboard.init(setLoaded);
          const token = localStorage.getItem("token") || "";
          const res = await getUrl(topicId, `Token ${token.slice(1, -1)}`);

          if(res){
            dashboard.changeSettings(
                {
                    url:res[0],
                    container:'#hey-alpha-embed-container'
                }
            )
            await dashboard.embedDash();
          }
        };

        handleDash(topicId)
      }, [topicId]);
    return (
        <>

        <IonContent id="hey-alpha-embed-container" style={{height:'93%'}}>
            {loaded ? null :
            <LoadingDots/>
            }
            </IonContent>
        </>
    );
};

export default QuicksightQ;
